import type { Component } from 'vue';
import type { MenuItemOptions } from '@/components/action_menu/__types__/ActionMenuTypes';

const SUPPORT_TICKET_BASE_URL = 'https://support.sittercity.com/hc/en-us/requests/new?&ticket_form_id=360000078194';

export function getSupportTicketHref(currentChannelUrl: string): string {
  const channelUrlParam = currentChannelUrl ? `&channel_url=${currentChannelUrl}` : '';
  return `${SUPPORT_TICKET_BASE_URL}${channelUrlParam}`;
}

export function buildReportMenuItem(supportTicketHref: string, icon: Component, height: number, width: number): MenuItemOptions {
  return {
    icon,
    height,
    width,
    labelText: 'Report',
    href: supportTicketHref,
    target: '_self',
    click: () => {},
  };
}
